
    var riot = require('riot')
    //src: starling/src/tags/menu/items/menu-item-create-card.html
riot.tag2('menu-item-create-card',
  '<svg class="floating-menu_icon" viewbox="0 0 15 18"> <path fill="#52A2F4" d="M14.14125,12.8595 C14.2485,12.96675 14.28075,13.128 14.22225,13.26825 C14.1645,13.4085 14.02725,13.5 13.87575,13.5 L11.51325,13.5 L13.0785,16.31775 C13.12875,16.40775 13.14,16.5135 13.10925,16.611 C13.07925,16.7085 13.01025,16.7895 12.91875,16.83525 L10.66875,17.96025 C10.61475,17.98725 10.55775,18 10.5015,18 C10.3695,18 10.242,17.9295 10.173,17.8065 L8.511,14.8155 L6.60675,16.305 C6.49425,16.3935 6.34125,16.41 6.2115,16.34625 C6.0825,16.284 6.00075,16.15275 6.00075,16.0095 L6.00075,5.625 C6.00075,5.4735 6.09225,5.33625 6.2325,5.2785 C6.3735,5.22 6.534,5.25225 6.64125,5.3595 L14.14125,12.8595 Z M4.389,10.07625 C4.57875,10.16025 4.6635,10.38225 4.57875,10.57125 C4.5165,10.71075 4.37925,10.79325 4.236,10.79325 C4.185,10.79325 4.13325,10.7835 4.08375,10.761 C2.71125,10.149 1.65975,9.039 1.12275,7.63575 C0.5865,6.2325 0.62775,4.704 1.23975,3.33225 C2.50425,0.4995 5.838,-0.7755 8.6685,0.48825 C10.041,1.10025 11.0925,2.21025 11.6295,3.6135 C12.1665,5.01675 12.1245,6.54525 11.5125,7.917 C11.42775,8.106 11.2065,8.19225 11.0175,8.10675 C10.82775,8.02275 10.743,7.80075 10.82775,7.61175 C11.9235,5.157 10.81725,2.26875 8.36325,1.173 C5.91,0.0795 3.021,1.1835 1.9245,3.6375 C0.82875,6.09225 1.935,8.9805 4.389,10.07625 Z M5.2695,8.00475 C5.45775,8.0925 5.53875,8.31525 5.45175,8.5035 C5.388,8.64 5.25225,8.72025 5.11125,8.72025 C5.05875,8.72025 5.00475,8.709 4.95375,8.68575 C4.13625,8.3055 3.516,7.62975 3.20625,6.783 C2.8965,5.93625 2.9355,5.01975 3.31575,4.20225 C3.696,3.38475 4.37175,2.7645 5.2185,2.45475 C6.06525,2.145 6.9825,2.18475 7.79925,2.56425 C8.61675,2.9445 9.237,3.62025 9.54675,4.467 C9.8565,5.31375 9.8175,6.23025 9.43725,7.04775 C9.3495,7.23525 9.1275,7.31625 8.9385,7.23 C8.75025,7.14225 8.66925,6.91875 8.75625,6.73125 C9.05175,6.096 9.0825,5.38275 8.84175,4.72425 C8.601,4.065 8.11875,3.54 7.48275,3.2445 C6.84675,2.949 6.135,2.919 5.47575,3.159 C4.8165,3.39975 4.2915,3.882 3.996,4.518 C3.7005,5.15325 3.66975,5.8665 3.9105,6.525 C4.15125,7.18425 4.63425,7.70925 5.2695,8.00475 Z"></path> </svg> <span class="floating-menu_label">Create a card</span> <popover title="Upgrade to Plectica Pro for unlimited cards…" size="small" position="right" ref="upgradeWarning" closable="{false}"> You\'ve reached your limit of {this.FREE_CARD_LIMIT} free cards. To continue creating new cards, <a onclick="{showPaymentModal}" class="popover_inline_link">upgrade to Plectica Pro</a> </popover>',
  '',
  'class="floating-menu_item" onclick="{createNode}" onmouseenter="{maybeShowWarning}" onmouseleave="{maybeHideWarning}"', function(opts) {
'use strict';

var _this = this;

var _upsellUi = require('lib/upsell-ui');

var _constants = require('lib/constants');

var _util = require('lib/util');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.FREE_CARD_LIMIT = _constants.FREE_CARD_LIMIT;
var canvas = this.parent.opts.canvas;
this.showPaymentModal = function (e) {
  canvas.showPaymentModal(e);
};
this.createNode = function (e) {
  e.stopPropagation();
  e.preventDefault();

  canvas.createNodeOnDblClick({
    clientX: _this.parent.x + 60,
    clientY: _this.parent.y + 30
  });
  _eventTracking2.default.track({
    category: (0, _util.getTrackingLabel)(_this.parent),
    action: 'Create Card',
    label: 'Create'
  });
  _this.parent.hide();
};

this.maybeHideWarning = function () {
  if (_this.overLimit()) {
    _this.refs.upgradeWarning.hide();
  }
};

this.maybeShowWarning = function () {
  _this.parent.hideSubMenus();
  if (_this.overLimit()) {
    _this.refs.upgradeWarning.show();
  }
};

this.overLimit = function () {
  return _upsellUi.usui.userIsOverLimit();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-item-create-card')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/items/menu-item-create-card.html
// module id = 708
// module chunks = 0